<script>
  import ResourceList from "../components/ResourceList.svelte";
  import { Head, Body, Row, Cell } from "@smui/data-table";
  import { navigate } from "svelte-routing";

  export let location;
  export let title;
  let resource = "users";
  let records;

  title = resource;

  function edit(id) {
    navigate(`${location.pathname}/${id}`);
  }
</script>

<ResourceList {resource} {location} bind:records>
  <Head>
    <Row>
      <Cell>Name</Cell>
      <Cell>Role</Cell>
      <Cell>Email Verified</Cell>
      <Cell>Login Allowed</Cell>
    </Row>
  </Head>
  <Body>
    {#if records}
      {#each records as row}
        <Row on:click={() => edit(row.id)} class="pointer mdc-data-table__row">
          <Cell>
            <span>{row.name}</span>
            <br />
            <span>
              <a href="mailto:{row.email}">{row.email}</a>
            </span>
          </Cell>
          <Cell>{row.role}</Cell>
          <Cell>
            {#if row.verified}
              <i class="material-icons">check</i>
            {:else}
              <i class="material-icons">clear</i>
            {/if}
          </Cell>
          <Cell>
            {#if row.login_allowed}
              <i class="material-icons">check</i>
            {:else}
              <i class="material-icons">clear</i>
            {/if}
          </Cell>
        </Row>
      {/each}
    {/if}
  </Body>
</ResourceList>
